import { ClientConfigProductName } from '@frontend/vanilla/core';

export const StoryContentLoader = {
    id: 'story-content',
    loaderFn: () => import(/* webpackChunkName: "ms-story-content" */ './story-content.feature'),
    product: ClientConfigProductName.SPORTS,
};
